import { useState } from "react";
import useGetHook from "../../customHooks/useGetHook";
import Button from "../Reusable/Button";
//@ts-ignore
//@ts-ignore
import { tw } from "@careinfo/tailwind";
//@ts-ignore
import { usePDFPrintHook } from "@careinfo/layout";
import moment from "moment";
import APIS from "../../constant/EndPoint";
import { responsiveClassName } from "../../utils/classNames";
import Modal from "../Reusable/Modal";
import MakePayment from "./MakePayment";
const InvoicePreview = (props: any) => {
  const { order, id } = props;
  const [makePayment, setMakePayment] = useState(false);

  const { data: clientData } = useGetHook({
    queryKey: [`client-setting`],
    url: `${APIS.CLIENT_SETTING}`,
    params: {},
  });

  const { downloadPrint, isPrintLoading } = usePDFPrintHook();

  const handlePrint = async () => {
    const url = `${APIS.INVOICE}${id}/print-pdf-invoice/`;
    let formData = {};
    try {
      const res = await downloadPrint(url);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div className={tw`max-w-[85rem] px-4 sm:px-6 mx-auto`}>
        <div className={tw`sm:w-11/12 lg:w-3/4 mx-auto`}>
          <div className={tw`mb-6 flex justify-end gap-x-3 `}>
            <div className={tw`w-32 flex gap-x-8`}>
              <Button
                label="Print"
                type="button"
                onClick={handlePrint}
                isLoading={isPrintLoading}
              />
            </div>
          </div>
          {/* Card */}
          <div
            className={tw`flex flex-col p-4 sm:p-10 bg-white shadow-md rounded-xl `}
          >
            {/* Grid */}
            <div className={tw`flex justify-between`}>
              <div>
                <img
                  className={tw`h-[4rem] object-contain`}
                  src={clientData?.logo}
                  alt="logo"
                />
              </div>
              {/* Col */}

              <div className={tw`text-right`}>
                <h2
                  className={tw`text-2xl md:text-3xl font-semibold text-gray-500 `}
                >
                  Invoice #
                </h2>
                <span className={tw`mt-1 block text-gray-500`}>
                  {order?.invoice_id}
                </span>
                <address className={tw`mt-1 not-italic text-gray-500 `}>
                  {clientData?.address ?? "N/A"}
                  <br />
                </address>
              </div>
              {/* Col */}
            </div>
            {/* End Grid */}

            {/* Grid */}
            <div
              className={responsiveClassName(
                `mt-8 text-sm grid grid-cols-1 gap-1`,
                `mt-8 text-sm grid grid-cols-2  gap-3`
              )}
            >
              <div>
                <h3 className={tw` font-semibold text-gray-500 `}>Bill to:</h3>
                <h3 className={tw` font-semibold text-gray-500  capitalize`}>
                  {order?.user?.full_name ?? "N/A"}
                </h3>
                <p className={tw`font-semibold text-gray-500   `}>
                  PAN/VAT :{order?.merchant_pan}
                </p>
                <address className={tw`mt-2 not-italic text-gray-500`}>
                  {order?.user?.mobile_number ?? "N/A"},<br />
                  {order?.user?.email ?? "N/A"},<br />
                  Kathmandu, Nepal
                  <br />
                </address>
              </div>
              {/* Col */}

              <div
                className={responsiveClassName(
                  `text-left space-y-2`,
                  `text-right space-y-2`
                )}
              >
                {/* Grid */}
                <div
                  className={responsiveClassName(
                    `grid grid-cols-1 gap-1`,
                    "grid grid-cols-2 sm:grid-cols-1 gap-3 sm:gap-2"
                  )}
                >
                  <dl className={tw`grid grid-cols-5 gap-x-3 `}>
                    <dt
                      className={tw`col-span-3 text-sm font-semibold text-gray-500  `}
                    >
                      Invoice date:
                    </dt>
                    <dd className={tw`col-span-2  text-sm text-gray-500`}>
                      {moment(order?.created).format("YYYY/MM/DD ")}
                    </dd>
                  </dl>
                  <dl className={tw`grid grid-cols-5  text-sm  gap-x-3`}>
                    <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                      Payment Method:
                    </dt>
                    <dd className={tw`col-span-2   text-gray-500 uppercase`}>
                      {order?.payment_method ?? "N/A"}
                    </dd>
                  </dl>
                  <dl className={tw`grid grid-cols-5  text-sm gap-x-3`}>
                    <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                      Payment date:
                    </dt>
                    <dd className={tw`col-span-2 text-gray-500`}>
                      {order?.settlement_date
                        ? moment(order?.settlement_date).format("YYYY/MM/DD")
                        : "N/A"}
                    </dd>
                  </dl>
                  <dl className={tw`grid  text-sm  grid-cols-5 gap-x-3`}>
                    <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                      Payment Status:
                    </dt>
                    <dd className={tw`col-span-2 text-gray-500 uppercase`}>
                      {order?.status}
                    </dd>
                  </dl>
                  {order?.date_range && (
                    <dl className={tw`grid  text-sm  sm:grid-cols-5 gap-x-3`}>
                      <dt
                        className={tw`col-span-3 font-semibold text-gray-500 `}
                      >
                        Date Range:
                      </dt>

                      <dd className={tw`col-span-2 text-gray-500 uppercase`}>
                        {order?.date_range?.lower},{order?.date_range?.upper}
                      </dd>
                    </dl>
                  )}
                </div>
                {/* End Grid */}
              </div>
              {/* Col */}
            </div>
            {/* End Grid */}

            {/* Table */}
            <div className={tw`w-full overflow-x-auto`}>
              <table
                className={tw`mt-6 border border-gray-400 p-4 rounded-lg  space-y-4  w-full `}
              >
                <thead>
                  <tr className={tw`text-center border-b border-gray-400 `}>
                    <th
                      className={tw`text-xs font-medium text-gray-500 uppercase`}
                    >
                      SN
                    </th>
                    <th
                      className={tw` text-xs font-medium text-gray-500 uppercase`}
                    >
                      WAYBILL
                    </th>
                    <th
                      className={tw` text-xs font-medium text-gray-500 uppercase`}
                    >
                      DATE
                    </th>
                    <th
                      className={tw` text-xs font-medium text-gray-500 uppercase`}
                    >
                      REFERENCE
                    </th>

                    <th
                      className={tw` text-xs font-medium text-gray-500 uppercase`}
                    >
                      RECEIVER
                    </th>

                    <th
                      className={tw` text-xs   font-medium text-gray-500 uppercase`}
                    >
                      Pieces
                    </th>
                    <th
                      className={tw` text-xs   font-medium text-gray-500 uppercase`}
                    >
                      Weight
                    </th>
                    <th
                      className={tw` text-xs   font-medium text-gray-500 uppercase`}
                    >
                      COD
                    </th>
                    <th
                      className={tw` text-xs font-medium text-gray-500 uppercase`}
                    >
                      Cod Collected
                    </th>
                    <th
                      className={tw` text-xs font-medium text-gray-500 uppercase`}
                    >
                      D. Charge
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {order?.orders?.map((item: any, index: number) => (
                    <tr key={index} className={tw`text-center text-sm`}>
                      <td className={tw``}>
                        <p className={tw`font-medium text-gray-500 `}>
                          {index + 1}
                        </p>
                      </td>

                      <td className={tw``}>
                        <p className={tw` text-sm text-gray-500 `}>
                          {item?.tracking_number}
                        </p>
                        <p
                          className={tw`text-sm whitespace-nowrap text-center text-gray-500 `}
                        >
                          {item?.service_type?.name ??
                            item?.service_type ??
                            "N/A"}
                        </p>
                      </td>
                      <td className={tw``}>
                        <p className={tw` font-medium text-gray-500 `}>
                          {item?.created
                            ? moment(item?.created).format("YYYY/MM/DD")
                            : "N/A"}
                        </p>
                      </td>
                      <td className={tw``}>
                        <p className={tw` font-medium text-gray-500 `}>
                          {item?.reference_number}
                        </p>
                      </td>

                      <td className={tw``}>
                        <p
                          className={tw`font-medium text-gray-500  flex flex-col`}
                        >
                          {item?.receiver.full_name}

                          <p className={tw`font-sm`}>
                            {item?.receiver.primary_contact}
                          </p>
                          <p className={tw`font-sm`}>
                            {item?.receiver.address}
                          </p>
                        </p>
                      </td>

                      <td
                        className={tw`text-gray-500 text-center  whitespace-nowrap`}
                      >
                        {item?.piece ?? 0.0}
                      </td>
                      <td
                        className={tw`text-gray-500 text-center   whitespace-nowrap`}
                      >
                        {item?.weight ?? 0.0}
                      </td>
                      <td
                        className={tw`text-gray-500  text-center whitespace-nowrap`}
                      >
                        Rs. {item?.cod ?? 0.0}
                      </td>
                      <td>
                        <p className={tw`text-gray-500  `}>
                          Rs.{item?.collected_cod ?? 0.0}
                        </p>
                      </td>
                      <td>
                        <p className={tw`text-gray-500  `}>
                          Rs.{item?.delivery_charge ?? 0.0}
                        </p>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* End Table */}

            {/* Flex */}
            <div className={tw`mt-8 flex sm:justify-end`}>
              <div className={tw`w-full max-w-2xl sm:text-right space-y-2`}>
                {/* Grid */}
                <div className={tw`grid text-sm grid-cols-1 gap-3 `}>
                  <dl className={tw`grid grid-cols-5 gap-x-3`}>
                    <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                      Total Cod:
                    </dt>
                    <dd className={tw`col-span-2 text-gray-500`}>
                      Rs. {order?.amount ?? 0.0}
                    </dd>
                  </dl>

                  <dl className={tw`grid grid-cols-5 gap-x-3`}>
                    <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                      Collected Cod:
                    </dt>
                    <dd className={tw`col-span-2 text-gray-500`}>
                      Rs. {order?.total_charge?.collected ?? 0.0}
                    </dd>
                  </dl>

                  <dl className={tw`grid grid-cols-5 gap-x-3`}>
                    <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                      Deliver Charge:
                    </dt>
                    <dd className={tw`col-span-2 text-gray-500`}>
                      Rs. {order?.total_charge?.charge ?? 0.0}
                    </dd>
                  </dl>

                  <dl className={tw`grid grid-cols-5 gap-x-3`}>
                    <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                      Tax:
                    </dt>
                    <dd className={tw`col-span-2 text-gray-500`}>
                      Rs. {order?.tax}
                    </dd>
                  </dl>

                  <dl className={tw`grid grid-cols-5 gap-x-3`}>
                    <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                      Payable Amount:
                    </dt>
                    <dd className={tw`col-span-2 text-gray-500`}>
                      Rs. {order?.invoice_amount}
                    </dd>
                  </dl>
                </div>
                {/* End Grid */}
              </div>
            </div>
            {/* End Flex */}
            <div className={tw`mt-6 sm:mt-12`}>
              <h4 className={tw`text-lg font-semibold text-gray-500 `}>
                Thank you!
              </h4>
              <p className={tw`text-gray-500`}>
                If you have any questions concerning this invoice, use the
                following contact information:
              </p>
              <div className={tw`mt-2`}>
                <p className={tw`block text-sm font-medium text-gray-500 `}>
                  {clientData?.email}
                </p>
              </div>
            </div>

            <p className={tw`mt-5 text-sm text-gray-500 mx-auto`}>
              © {new Date().getFullYear()} {clientData?.business_name}.
            </p>
          </div>
          {/* End Card */}
        </div>
      </div>
      <Modal
        isOpen={makePayment}
        setIsOpen={setMakePayment}
        title={"Make Payment"}
        children={
          <>
            <MakePayment setMakePayment={setMakePayment} />
          </>
        }
      />
    </>
  );
};

export default InvoicePreview;
